import { render, staticRenderFns } from "./CheckLuggage.vue?vue&type=template&id=34ee4b2f&"
import script from "./CheckLuggage.vue?vue&type=script&lang=js&"
export * from "./CheckLuggage.vue?vue&type=script&lang=js&"
import style0 from "./CheckLuggage.vue?vue&type=style&index=0&id=34ee4b2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports